export const iconFontAwesomeTimeCalendarDay = (
	<i className="fa-solid fa-calendar-day"></i>
);
